import React, { useEffect, useState } from 'react';
import { isAllowEdit } from 'features/supplier/utils';

import AddBeneficiaryBankDetails from '@components/AddBeneficiaryBankDetails';
import NoData from '@components/NoData';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const BankDetails = ({ supplierId, isAdd, onSetAdd }) => {
	const [supplierBankDetailsList, setSupplierBankDetailsList] = useState([]);
	const [, setIsLoading] = useState(false);
	const [isAddBeneficiaryBank, setIsAddBeneficiaryBank] = useState(isAdd);
	const [selectedBankDetails, setSelectedBankDetails] = useState(null);

	useEffect(() => {
		getSupplierBankDetailsList(supplierId);
	}, [supplierId]);
	useEffect(() => {
		setIsAddBeneficiaryBank(isAdd);
	}, [isAdd]);

	const getSupplierBankDetailsList = async (id) => {
		setIsLoading(true);
		await ApiClient.GET('getSupplierBankDetailsList', id)
			.then(({ data }) => {
				setIsLoading(false);
				setSupplierBankDetailsList(data);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const onAddBeneficiaryBank = () => {
		onSetAdd();
	};

	const onResetSelectedItem = () => {
		setSelectedBankDetails(null);
	};

	return (
		<>
			{supplierBankDetailsList?.length === 0 ? (
				<NoData message="No Bank info added" />
			) : (
				<div className="row" id="bank-details-section">
					{supplierBankDetailsList.map((item) => (
						<div className="col-md-6 padding-col" key={item.id}>
							<div className="location-details bank-details">
								<div className="location-heading">
									<span className="semibold-12">{item.title}</span>
									{isAllowEdit() && (
										<img
											src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
											alt="edit"
											onClick={() => {
												setIsAddBeneficiaryBank(true);
												setSelectedBankDetails(item);
											}}
										/>
									)}
								</div>

								<div className="details-with-default d-flex justify-content-between">
									<div className="full-details ">
										<div className="info-details d-flex">
											<span className="regular-14 gray_dark_01">
												{item.bankDetails}
											</span>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">SWIFT CODE</p>
											<p className="regular-14 gray_dark_02">:</p>
											<p className="regular-14">{item?.swiftCode}</p>
										</div>
										<div className="info-details d-flex">
											<p className="regular-14 gray_dark_02">CD A/C NO</p>
											<p className="regular-14 gray_dark_02">:</p>
											<p className="regular-14">{item?.accountNumber}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			)}
			{isAddBeneficiaryBank && (
				<AddBeneficiaryBankDetails
					isEditable={!!selectedBankDetails}
					onAddBeneficiaryBank={onAddBeneficiaryBank}
					selectedItem={selectedBankDetails}
					getSalesContractDetailsInfo={getSupplierBankDetailsList}
					supplierId={supplierId}
					isFromSupplier={true}
					onResetSelectedItem={onResetSelectedItem}
				/>
			)}
		</>
	);
};

export default BankDetails;
